/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_8_AInputs */

const en_pc_faq_8_a = /** @type {(inputs: Pc_Faq_8_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. This is an independent guide. The official page is getartcraft.com/apps/photocraft and the source is at github.com/storytold/photocraft. We are not affiliated with ArtCraft or Adobe.`)
};

const zh_pc_faq_8_a = /** @type {(inputs: Pc_Faq_8_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不是。本站是独立的指南站。官方页面是 getartcraft.com/apps/photocraft，源码在 github.com/storytold/photocraft。我们与 ArtCraft、Adobe 均无关联。`)
};

/**
* | output |
* | --- |
* | "No. This is an independent guide. The official page is getartcraft.com/apps/photocraft and the source is at github.com/storytold/photocraft. We are not affil..." |
*
* @param {Pc_Faq_8_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_8_a = /** @type {((inputs?: Pc_Faq_8_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_8_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_8_a(inputs)
	return zh_pc_faq_8_a(inputs)
});
export { pc_faq_8_a as "pc.faq.8.a" }